import { Injectable } from "@angular/core";
import {
  HttpHeaders,
  HttpClient,
} from "@angular/common/http";
import { environment } from "environments/environment";
import "rxjs/add/operator/catch";
import { Observable } from "rxjs";

const httpOptions = {
  headers: new HttpHeaders({
    Authorization: "Bearer " + localStorage.getItem("token"),
    "Content-Type": "application/json; charset=utf-8",
  }),
};

@Injectable({
  providedIn: 'root'
})
export class DashboardService  {
  baseUrl: string;
  baseUrlFinanca: string;
  baseUrlCliente: string;

  constructor(private http: HttpClient) {
    this.baseUrlFinanca = `${environment.apiFinancas}dashboard/`;
    this.baseUrlCliente = `${environment.apiClientes}dashboard/`;
  }

  metricas_venda_totais(utilizador:any): Observable<any> {
    return this.http
      .post(this.baseUrlFinanca + "metricasVenda/totais",utilizador,httpOptions)
      .pipe();
  }

  metricas_venda_grafico(utilizador:any): Observable<any> {
    return this.http
      .post(this.baseUrlFinanca + "metricasVenda/graficos",utilizador,httpOptions)
      .pipe();
  }

  metricas_tesouraria_totais(utilizador:any): Observable<any> {
    return this.http
      .post(this.baseUrlFinanca + "metricasTesouraria/totais",utilizador,httpOptions)
      .pipe();
  }

  metricas_tesouraria_grafico(utilizador:any): Observable<any> {
    return this.http
      .post(this.baseUrlFinanca + "metricasTesouraria/graficos",utilizador,httpOptions)
      .pipe();
  }
  metricas_compra_totais(utilizador:any): Observable<any> {
    return this.http
      .post(this.baseUrlFinanca + "metricasCompra/totais",utilizador,httpOptions)
      .pipe();
  }

  metricas_compra_grafico(utilizador:any): Observable<any> {
    return this.http
      .post(this.baseUrlFinanca + "metricasCompra/graficos",utilizador,httpOptions)
      .pipe();
  }
  metricas_Cliente_totais(metricas:any): Observable<any> {
    return this.http
      .post(this.baseUrlCliente + "metricasCliente/totais",metricas,httpOptions)
      .pipe();
  }

  metricas_Cliente_grafico(metricas:any): Observable<any> {
    return this.http
      .post(this.baseUrlCliente + "metricasCliente/graficos",metricas,httpOptions)
      .pipe();
  }

  dadosFiltro(): Observable<any> {
    return this.http
      .get(this.baseUrlFinanca + "dadosFiltro",httpOptions)
      .pipe();
  }

  notificacoes(): Observable<any> {
    return this.http
      .get(this.baseUrlFinanca + "notificacoes",httpOptions)
      .pipe();
  }
}